import React, { useEffect, useState } from "react";
import mediumZoom from "medium-zoom";
import FetchData from "@ezviz/FetchData";
import DocContent from "../components/DocContent";
import SliderMenu from "../components/SliderMenu";
import FixedBar from "../component/FixedBar";
import Nav from "../component/Nav";
import { Result, Button } from "@ezviz/ezd";
import { useHistory } from "react-router-dom";

// import utils from '../../utils'
import "./index.less";
import "@ezviz/ezd/dist/ezd.css";
import Footer from "../component/Footer";

const fetchFileContent = (param, callback = () => {}) => {
  const fetchData = new FetchData("/web/console/doc/center/doc/get", {
    method: "GET",
    body: param,
  });
  fetchData
    .then((res) => {
      if (res.meta.code == 200) {
        callback(res.data);
      } else {
      }
    })
    .catch((e) => {
      // message.destroy();
      // message.error('请求失败');
    });
};

const accessCount = (param, callback = () => {}) => {
  const fetchData = new FetchData(`/web/console/doc/center/doc/access/count`, {
    method: "POST",
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: {
      docId: param,
    },
  });
  fetchData
    .then((res) => {
      if (res.meta.code == 200) {
        callback(res.data);
      } else {
      }
    })
    .catch((e) => {
      // message.destroy();
      // message.error('请求失败');
    });
};

// 获取菜单
const fetchMenuInfo = (param, callback = () => {}) => {
  const defaultObj = {
    pageStart: 1,
    pageSize: 1,
  };
  const body = Object.assign({}, defaultObj, param);
  const fetchData = new FetchData("/help/api/help_doc/doc/menu/info", {
    method: "GET",
    body,
  });
  fetchData
    .then((res) => {
      if (res.meta.code === 200) {
        callback(res.data.list[0]);
      } else {
        //   message.error(res.msg || '操作失败');
      }
    })
    .catch((e) => {
      // message.destroy();
      // message.error('请求失败');
    });
};

const OpenDoc = (props) => {
  const [menuData, setMenuData] = useState(null);
  const [htmlContent, setHtmlContent] = useState(" ");
  const history = useHistory();
  const [seo, setSeo] = useState({});
  useEffect(() => {
    if (seo.titleSeo) {
      const frm = document.createDocumentFragment("");
      let title = document.createElement("title");
      title.innerText = seo.titleSeo;
      frm.appendChild(title);

      let obj = {
        keywords: "keywordsSeo",
        description: "descSeo",
        "og:title": "ogTitleSeo",
        "og:site_name": "ogSiteNameSeo",
        "og:url": "ogUrlSeo",
        "og:description": "ogDescSeo",
        "og:type": "ogTypeSeo",
        "og:image": "ogImageSeo",
      };
      let meta = null;
      for (const key in obj) {
        console.log(key);
        meta = document.createElement("meta");
        meta.setAttribute("name", key);
        meta.setAttribute("content", seo[obj[key]]);
        frm.appendChild(meta);
        meta = null;
      }

      let head = document.getElementsByTagName("head")[0];
      head.append(frm);
    }
  }, [seo]);

  useEffect(() => {
    fetchMenuInfo({ platformType: "doc_open" }, (res) => {
      let { content, id } = res;
      let newData = JSON.parse(content);
      setMenuData(JSON.stringify(newData, null, 4));
    });
  }, []);

  // useEffect(() => {

  //   let zoom = null;

  //   setTimeout(() => {
  //     let images = document.getElementsByTagName("img"); // 获取页面上的所有图片
  //     for (let i = 0; i < images.length; i++) {
  //       if (!!images[i].style && images[i].style.zoom == "50%") {
  //         images[i].style.zoom = "1.0"; // 将 zoom 属性重置为 1.0
  //         images[i].style.width = "500px";
  //       }
  //     }
  //   }, 0);
  //   return () => {
  //     zoom.detach();
  //   };
  // }, [htmlContent]);

  const scroolPoint = () => {
    let query = props.location.hash;
    console.log("query", query);
    setTimeout(() => {
      // let dom = query && document.querySelector(query);
      // if (dom) {
      //   dom.scrollIntoView({ block: "center", behavior: "smooth" });
      // }
    }, 200);
  };

  // 遍历字符串，本次匹配https://open.ys7.com开头，但排除https://open.ys7.com/console开头
  const RegExpStr = (str) => {
    const domain = window.location.origin + "/";
    const newStr = str.replace(
      /https:\/\/open\.ys7\.com\/(?!console\/)/g,
      domain
    );
    return newStr;
  };

  useEffect(() => {
    let id = props.match.params.id;

    fetchFileContent({ docId: id }, (res) => {
      let { doc, seo } = res;
      const { content } = doc;
      setSeo(seo || {});

      if (doc) {
        accessCount(id); // 上传埋点数据
        const newStr = RegExpStr(content);
        setHtmlContent(newStr);
      } else {
        setHtmlContent("");
      }

      scroolPoint();
    });
  }, [props.match.params.id]);

  const [tangram, setTangram] = useState({});

  const fetchTangram = (param, callback = () => {}) => {
    const defaultObj = {
      pageStart: 1,
      pageSize: 1,
    };
    const body = Object.assign({}, defaultObj, param);
    const fetchData = new FetchData("/help/api/tangram/getData", {
      method: "GET",
      body,
    });
    fetchData
      .then((res) => {
        if (res.meta.code === 200) {
          callback(res.data);
        } else {
        }
      })
      .catch((e) => {});
  };

  useEffect(() => {
    fetchTangram({}, (e) => {
      setTangram(e);
    });
  }, []);

  return (
    <div className="open-doc">
      {tangram.header && <Nav {...tangram.header[0]} />}

      <SliderMenu
        lang={"zh"}
        data={menuData}
        setData={(data) => {
          setMenuData(data);
        }}
        style={{ width: 306, top: 45 }}
        activeId={props.match.params.id}
        htmlContent={htmlContent}
      ></SliderMenu>

      {tangram.footer &&
        tangram.footer.map((item) => {
          if (item.componentType == "fixedBar") {
            return <FixedBar {...item} />;
          }
          if (item.componentType == "footer") {
            return <Footer {...item} />;
          }
        })}
    </div>
  );
};

export default OpenDoc;
